import * as columnConstants from '../dataTable/constants'
import * as dbConstants from '../../dao/dbConstants'

const getOrderByObject = (fieldName, sortDirection=columnConstants.SORT_DIRECTION_ASCENDNG) => {
  return {orderBy: fieldName, sortDirection: sortDirection}
}

const articleDefaultSortBy = getOrderByObject('name');
const campaignDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);
const companyDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);
const contentDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);
const firmDefaultSortBy = getOrderByObject('name', columnConstants.SORT_DIRECTION_ASCENDNG);
const billingDefaultSortBy = getOrderByObject('createdOn', columnConstants.SORT_DIRECTION_DESCENDING);
const personaDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);
const productDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);
const sourceContentDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);
const topicDefaultSortBy = getOrderByObject('name');
const userDefaultSortBy = getOrderByObject('firstName');
const writingStyleDefaultSortBy = getOrderByObject('updatedOn', columnConstants.SORT_DIRECTION_DESCENDING);
const roleDefaultSortBy = getOrderByObject('name');
const linkDefaultSortBy = getOrderByObject('title');
const testimonialDefaultSortBy = getOrderByObject('publishDate', columnConstants.SORT_DIRECTION_DESCENDING);
const publishDefaultSortBy = getOrderByObject('publishDate', columnConstants.SORT_DIRECTION_DESCENDING);
const promptTemplateDefaultSortBy = getOrderByObject('name');
const instructionBlockDefaultSortBy = getOrderByObject('sortOrder');
const supportRequestDefaultSortBy = getOrderByObject('createdOn', columnConstants.SORT_DIRECTION_DESCENDING);
const backofficeUserDefaultSortBy = getOrderByObject('firstName');
const contentValidatorDefaultSortBy = getOrderByObject('name');

const defaultSortBy = {
  [dbConstants.ENTITY_NAME_ARTICLE]: articleDefaultSortBy,
  [dbConstants.ENTITY_NAME_CAMPAIGN]: campaignDefaultSortBy,
  [dbConstants.ENTITY_NAME_COMPANY]: companyDefaultSortBy,
  [dbConstants.ENTITY_NAME_PRODUCT]: productDefaultSortBy,
  [dbConstants.ENTITY_NAME_PERSONA]: personaDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_FIRM]: firmDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_BILLING_METRICS]: billingDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_PROMPT_TEMPLATE]: promptTemplateDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_INSTRUCTION_BLOCK]: instructionBlockDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST]: supportRequestDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_USER]: backofficeUserDefaultSortBy,
  [dbConstants.ENTITY_NAME_CONTENT]: contentDefaultSortBy,
  [dbConstants.ENTITY_NAME_SOURCE_CONTENT]: sourceContentDefaultSortBy,
  [dbConstants.ENTITY_NAME_USER]: userDefaultSortBy,
  [dbConstants.ENTITY_NAME_WRITING_STYLE]: writingStyleDefaultSortBy,
  [dbConstants.ENTITY_NAME_TOPIC]: topicDefaultSortBy,
  [dbConstants.ENTITY_NAME_ROLE]: roleDefaultSortBy,
  [dbConstants.ENTITY_NAME_PUBLISH]: publishDefaultSortBy,
  [dbConstants.ENTITY_NAME_LINK]: linkDefaultSortBy,
  [dbConstants.ENTITY_NAME_TESTIMONIAL]: testimonialDefaultSortBy,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_CONTENT_VALIDATOR]: contentValidatorDefaultSortBy,
}

export const getDefaultOrderBy = (entityName) => {
  return defaultSortBy[entityName]
}
